export const phoneRegex = /^\+?\d+$/
